import PropTypes from 'prop-types'
import PrimaryButton from '../buttons/PrimaryButton'
import {
  CareerApplyWrapper,
  CareerChip,
  CareerChipsRow,
  CareerDetailAvatar,
  CareerDetailAvatarImage,
  CareerDetailBanner,
  CareerDetailBody,
  CareerDetailCard,
  CareerDetailCompany,
  CareerDetailTitle,
  BannerDecorCircleLarge,
  BannerDecorCircleSmall,
} from '../styled'
import CheckSquare from '../../assets/svgs/CheckSquare'
import { useTranslation } from 'react-i18next'
import { convertToNormalText } from '../../utilities/stringUtilities'

export function JobHeader({
  companyName,
  logoUrl,
  city,
  country,
  workplaceType,
  employmentType,
  title,
  invitationLink,
  easyApplyLink,
  getInitials,
}) {
  const { t } = useTranslation()

  const applicationLink = easyApplyLink || invitationLink
  const isEasyApply = !!easyApplyLink

  const chips = [
    city,
    country,
    convertToNormalText(workplaceType),
    convertToNormalText(employmentType),
  ].filter(Boolean)

  return (
    <CareerDetailCard>
      <CareerDetailBanner>
        <BannerDecorCircleLarge />
        <BannerDecorCircleSmall />
      </CareerDetailBanner>
      <CareerDetailBody>
        <CareerDetailAvatar>
          {logoUrl ? (
            <CareerDetailAvatarImage
              loading="lazy"
              src={logoUrl}
              alt="company logo"
            />
          ) : (
            getInitials(companyName)
          )}
        </CareerDetailAvatar>
        <CareerDetailCompany>{companyName}</CareerDetailCompany>
        <CareerDetailTitle>{title}</CareerDetailTitle>
        {chips.length > 0 && (
          <CareerChipsRow>
            {chips.map((chip) => (
              <CareerChip key={chip}>{chip}</CareerChip>
            ))}
          </CareerChipsRow>
        )}
        <CareerApplyWrapper>
          <PrimaryButton
            width="100%"
            onClick={() =>
              window.open(`/job-application/${applicationLink}`, '_blank')
            }
            disabled={!applicationLink}
          >
            <CheckSquare
              width="16"
              height="16"
              color="#fff"
              style={{ marginRight: '8px' }}
            />
            {isEasyApply ? t('careers.easyApply') : t('careers.applyNow')}
          </PrimaryButton>
        </CareerApplyWrapper>
      </CareerDetailBody>
    </CareerDetailCard>
  )
}

JobHeader.propTypes = {
  companyName: PropTypes.string.isRequired,
  logoUrl: PropTypes.string,
  city: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired,
  workplaceType: PropTypes.string.isRequired,
  employmentType: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  invitationLink: PropTypes.string,
  easyApplyLink: PropTypes.string,
  getInitials: PropTypes.func.isRequired,
}
